<template>
<container>
  <div class="runners">
    <div class="runners__content">

      <div class="search">
        <v-text-field
          :block="true"
          placeholder="Search by name, location, e-mail, promocode"
          v-model="search"
          @keyup.enter="handleSearch"/>

          <div class="total-results">
            {{ AllRunners.count }} results
            {{ searching ? ` for ${searchValue}` : ''}}
          </div>
      </div>

      <responsive>
        <table class="table">
          <thead>
            <th id="ID" style="min-width: 90px">ID</th>
            <th id="RunnerName" style="min-width: 200px">Runner name</th>
            <th id="Location" style="min-width: 150px">Location</th>
            <th id="Gender" style="min-width: 80px">Gender</th>
            <th id="E-mail" style="min-width: 300px">E-mail</th>
            <th id="Facebook" style="min-width: 100px">Facebook</th>
            <th id="AccountCreate" style="min-width: 150px">Account Create</th>
            <th id="MembershipTrialStart" style="min-width: 180px">Membership trial start</th>
            <th id="MembershipTrialEnd" style="min-width: 180px">Membership trial end</th>
            <th id="PromoCode" style="min-width: 150px">Promo code</th>
            <th id="PromoTrialStart" style="min-width: 180px">Promo trial start</th>
            <th id="PromoTrialEnd" style="min-width: 180px">Promo trial end</th>
            <th id="Height" style="min-width: 95px">Height</th>
            <th id="Weight" style="min-width: 95px">Weight</th>
            <th id="ProfileText" style="min-width: 300px">Profile text</th>
            <th id="Website" style="min-width: 300px">Website</th>
            <th id="TotalCompletedRuns" style="min-width: 180px">Total Completed Runs</th>
            <th id="LastLiveRun" style="min-width: 150px">Last LiveRun</th>
            <th id="DaysSinceLastLiveRun" style="min-width: 200px">Days since last LiveRun</th>
           
            <th></th>
          </thead>

          <tbody>
            <tr v-for="(runner, index) in AllRunners.runners" :key="index">
              <td><a href= "javascript:void(0)" @click  = getRunnersData(runner.id) > {{runner.id }}</a></td>
              <td>{{ runner.name || '-' }}</td>
              <td>{{ runner.location || '-' }}</td>
              <td class="center">{{ runner.gender || '-' }}</td>
              <td>{{ runner.user.email || '-' }}</td>
              <td>{{ runner.facebook ? 'Yes' : 'No' }}</td>
              <td>{{ runner.user.accountCreate || '-' }}</td>
              <td class="center">{{ runner.membership ? runner.membership.startDate : '-' }}</td>
              <td class="center">{{ runner.membership ? runner.membership.endDate : '-' }}</td>

              
              
              <!-- Show start and end date of promocode if promocode present .Get promocode from membership-->
              <td class="center">{{ runner.membership ? (runner.membership.promoCode ? runner.membership.promoCode : '-') : '-' }}</td>
              
              <td class="center" v-if="runner.membership && runner.membership.promoStartDate">{{  runner.membership.promoStartDate && runner.membership.promoCode ? runner.membership.promoStartDate : '-'}}</td>
              <td class="center" v-else>{{ runner.promo_report && runner.membership ? ( runner.promo_report.startDate && runner.membership.promoCode ? runner.promo_report.startDate : '-') : '-' }}</td>

              <td class="center" v-if="runner.membership && (runner.membership.promoEndDate || runner.membership.expirationDate)">{{ runner.membership.promoEndDate && runner.membership.promoCode  ? runner.membership.promoEndDate : (runner.membership.expirationDate && runner.membership.promoCode ? runner.membership.expirationDate:'-')  }}</td>
              <td class="center" v-else>{{ runner.promo_report && runner.membership ? ( runner.promo_report.endDate && runner.membership.promoCode ? runner.promo_report.endDate:'-' ) : '-' }} 
              <!-- -------------------------- -->


              <td class="center">{{ runner.height || '-' }}</td>
              <td class="center">{{ runner.weight || '-' }}</td>
              <td>{{ unicodeToChar(runner.profileText) || '-' }}</td>
              <td>{{ runner.website || '-' }}</td>
              <td class="center">{{ runner.runner_report.totalCompletedRuns || '0' }}</td>
              <td class="center">{{ runner.runner_report.lastLiveRun || '-' }}</td>
              <td class="center">{{ runner.runner_report.daysSinceLastLiveRun || '0' }}</td>              
             
            </tr>
          </tbody>
        </table>
      </responsive>

      <paginate
        :page-count="AllRunners.pagination.totalPages"
        :click-handler="handlePaginate"
        :prev-text="'Prev'"
        :next-text="'Next'"
        :container-class="'pagination'"
        :page-class="'pagination__item'"
        ref="paginate">
      </paginate>
    </div>
  </div>
  </container>
</template>

<script>
import Container from '@/components/Container'
import Paginate from 'vuejs-paginate'
import Responsive from '@/components/Responsive'
import VTextField from '@/components/Forms/VTextField'
import VButton from '@/components/Forms/VButton'
import runnersService from '@/services/runnersService'

import { mapActions } from 'vuex'

export default {
  name: 'AllRunners',
  data: () => {
    return {
      search: '',
      searchValue: '',
      searching: false,
      currentPage: 1,
      loading: false,
      AllRunners: {
        count: 0,
        pagination: {
          totalPages: 0,
          nextPage: null,
          prevPage: null
        },
        runners: []
      }
    }
  },
  computed: {
    trainer () {
      return this.$store.getters['Trainer/trainer']
    }
  },
  async mounted() {
    await this.loadRunners()
  },
  methods: {
    async loadRunners() {
      try {
        this.loading = true
        console.log('Loading runners with params:', {
          page: this.currentPage,
          limit: 50,
          search: this.searchValue
        })
        
        const response = await runnersService.getAllRunners({
          page: this.currentPage,
          limit: 50,
          search: this.searchValue
        })
        
        console.log('API response:', response)
        
        if (response.body && response.body.success && response.body.data && response.body.data.AllRunners) {
          this.AllRunners = response.body.data.AllRunners
          console.log('Successfully loaded runners:', this.AllRunners)
        } else {
          console.error('Unexpected API response format:', response)
          this.AllRunners = {
            count: 0,
            pagination: { totalPages: 0 },
            runners: []
          }
        }
      } catch (error) {
        console.error('Error loading runners:', error)
        this.AllRunners = {
          count: 0,
          pagination: { totalPages: 0 },
          runners: []
        }
      } finally {
        this.loading = false
      }
    },

    async handlePaginate (page) {
      this.currentPage = page
      await this.loadRunners()
    },

    unicodeToChar(text) {
        if(text != null)
    return text.replace(/\\u[\dA-F]{4}/gi, 
            function (match) {
                return String.fromCharCode(parseInt(match.replace(/\\u/g, ''), 16))
            })
    },

    getRunnersData(id){
          let route = this.$router.resolve({
                    name: 'runner-data',
                    params: {
                          runnerId: id,
                          raceId: 2285
                    }
                    })
              window.open(route.href, '_blank')
    },

    async handleSearch () {
      this.currentPage = 1
      //search runner by promocode
      this.searchValue = this.search
      await this.loadRunners()
      this.$refs.paginate.selected = 0
    },
    // deactivateRunner(runner){
    //        console.log(runner)
    // },
    ...mapActions({
      // deactivateRunner: 'runners/deactivate',
    //   toggleLoading: 'loading/toggleActive'
    })
  },
  components: {
    Paginate,
    Responsive,
    VTextField,
    VButton,
    Container
  }
}
</script>

<style lang="stylus" scoped>
   .runners
    display initial
    flex-flow row wrap

    &__content
      background #fff
      box-shadow 0 2px 6px 0 rgba(0,0,0,0.2)
      max-width 100%

      .search
        padding 20px
        text-align right
        background #f9f9f9

        .total-results
          font-size 11px
          color #222
          text-transform uppercase
          padding 3px

      table
        th:nth-child(1), th:nth-child(2)
          position sticky
          left 0
          background-color #c5c5c5

        th:nth-child(2)
          left 60px

        tr
          td:nth-child(1), td:nth-child(2)
            position sticky
            left 0
            background #fff

          td:nth-child(2)
            left 60px
            box-shadow: 5px 0 5px -5px rgba(#333, 0.30)

          &:nth-child(odd)
            td
              background #f9f9f9
</style>



// WEBPACK FOOTER //
// All.vue?b2856786